<script>
import * as m from '@app/paraglide/messages.js';
import {
    historyState,
    redoHistory
} from '@app/store/historyStore.svelte.js';
import {
    isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';

let isLocked = $derived(isSelectedEventGroupLocked());
let isDisabled = $derived(historyState.position === historyState.actions.length || isLocked);

function guardedRedo() {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }
    redoHistory();
}
</script>

<li class="nav-item" title={m.toolbar_secondary_redo_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        aria-label={m.toolbar_secondary_redo_aria_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        onclick={guardedRedo}
    ><i class="bi bi-arrow-clockwise"></i></a>
</li>
